import { ChartProps, ComponentClass, ComponentProps } from "src/lib/types/config";
import { TabStat } from "../types/config";


export const LiveChart = (props: ChartProps, template?: string) => ({
    componentClass: "LiveChart" as ComponentClass,
    props,
    template
});

export const Compass = (props: ChartProps, template?: string) => ({
    componentClass: "Compass" as ComponentClass,
    props,
    template
});

export const DataViewer = (props: {
    initialPeriod?: number,
    initialVariables?: string[],
    groupNames?: {[key in string]: string},
    settings: object,
    variablesList:  {
        key: string,
        label?: string,
        unit: string,
        format?: (v: number) => (string | number)
    }[],
    dataLoaderFormat?: object
}) => ({
    componentClass: "DataViewer" as ComponentClass,
    props: props as ComponentProps
});

export type RadarChartStyle = ChartProps['chartStyle'] & {
    anchor: {width: number, length: number}
}

type RadarProps = ChartProps & { chartStyle: RadarChartStyle }

export const MooringRadar =
    (props: RadarProps, template?: string) => ({
        componentClass: "MooringRadar" as ComponentClass,
        props,
        template
    });


export const AssetMap = (props = {}) => ({
    componentClass: "AssetMap" as ComponentClass,
    props: props as ComponentProps
});

export const TrackMap = (props = {}) => ({
    componentClass: "TrackMap" as ComponentClass,
    props: props as ComponentProps
});

export const Camera = (props = {}) => ({
    componentClass: "Camera" as ComponentClass,
    props: props as ComponentProps
});

export const ZDViewer = (props: {
    sources: {source: string, db?: boolean}[]
}) => ({
    componentClass: "ZDViewer" as ComponentClass,
    props: props as ComponentProps
});


export type StatComp =
    "ComputedStat" |
    "WeatherStat" |
    "Draft" |
    "Stat" |
    "PitchRollHeave" |
    "Coordinates" |
    "RealTimeStat" |
    "UTMCoordinates" | 
    "TimeStat";

export type ControlComp =
    "Selector" |
    "ReportButton"

export type StatComponentClass = StatComp | ControlComp;


type StatComponent = {
    componentClass: StatComp,
    props: object,
    stats: {[stat in string]: string}
} | {
    componentClass: ControlComp,
    props: object
};


export const Stats = (components: {[key in string]: StatComponent}, props: object = {}) => ({
    componentClass: "Stats" as ComponentClass,
    props: {components, ...props} as ComponentProps
});

export const LineTableStats = (props: {
    stats: TabStat[], 
    alarmsPeriod?: number, 
    title?: string,
    asset: number,
    elemsPerRow: number,
    type: "line" | "rope"
}) => ({
    componentClass: "LineTableStats" as ComponentClass,
    props: props as ComponentProps
});


export const MooringSummary = (props: object) => ({
    componentClass: "MooringSummary" as ComponentClass,
    props: props as ComponentProps
});

export const EventsTable = (props: {} = {}) => ({
    componentClass: "EventsTable" as ComponentClass,
    props,
});

export const LinesState = (props: {} = {}) => ({
    componentClass: "LinesState" as ComponentClass,
    props
});

export const LineLengthEditor = (props: {} = {}) => ({
    componentClass: "LineLengthEditor" as ComponentClass,
    props
});


export const UpdatesHistory = <DataType>(props: {
    objectType: string,
    updateType: string,
    selectedId: string,
    projection: {
        key: string,
        label: string,
        project: (
            update: {id: number, time: number, data: DataType}
        ) => string | number,
        sort?: "id" | "time"
    }[]
}) => ({
        componentClass: "UpdatesHistory" as ComponentClass,
        props: props as ComponentProps
    });